
import { Prop, Vue, Component } from "vue-property-decorator"
import vSelect from "vue-select"

@Component({
	components: {
		"v-select": vSelect
	}
})
export default class SimpleUserSelect extends Vue {
	@Prop()
	public value!: any
	@Prop()
	public userOptions!: any[]
}
